<template>
  <v-card outlined rounded="lg" class="pa-4" elevation="0">
    <v-row class="ma-0" v-if="!isResult">
      <v-col class="text-center" cols="12">
        <span>{{ $t('Período') }}</span>
        <div class="d-flex justify-center align-center mt-3">
          <v-menu
            ref="startDateMenu"
            :close-on-content-click="false"
            :return-value.sync="startDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                :disabled="isResult"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(startDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="startDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.startDateMenu.save(startDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>

          <span class="mx-2">{{ $t('Até') }}</span>

          <v-menu
            ref="endDateMenu"
            :close-on-content-click="false"
            :return-value.sync="filter.endDate"
            transition="scale-transition"
            @change="list"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                :disabled="isResult"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(endDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="endDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.endDateMenu.save(endDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>
        </div>
      </v-col>

      <v-col cols="12">
        <v-divider class="my-4"></v-divider>
      </v-col>
    </v-row>

    <v-alert
      type="warning"
      class="my-3 pa-1 text-center"
      v-if="services.length == 0"
    >
      {{ $t('Nenhum serviço encontrado') }}
    </v-alert>

    <div v-else>
      <v-row>
        <v-col cols="12" sm="6" md="6" lg="6">
          <GChart
            type="BarChart"
            :data="googleChartData"
            :options="opt"
            v-if="haveResponse"
          />
          <TNoContent v-else />
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6">
          <PieChart
            :chartData="pieChartData"
            :options="optionsPie"
            :plugins="plugins"
            :key="chartKey"
          />
        </v-col>
        <v-col cols="12">
          <div class="wrapper">
            <v-data-table
              :loading="loading"
              :loading-text="$t('Carregando...')"
              :no-data-text="$t('Nenhum dado encontrado')"
              :headers="headers"
              :items="services"
              class="main-table"
              :hide-default-footer="!filterProp.data"
              hide-default-header
              :header-props="headerProps"
              :items-per-page="10"
            >
              <template #header="{ props, on }">
                <thead>
                  <tr>
                    <th
                      class="text-center"
                      v-for="header in props.headers"
                      :key="header.value"
                    >
                      <v-simple-checkbox
                        v-if="header.value === 'data-table-select'"
                        v-model="props.everyItem"
                        :indeterminate="props.someItems && !props.everyItem"
                        color="purple"
                        @input="on['toggle-select-all']"
                      ></v-simple-checkbox>

                      <div>
                        <v-hover v-slot="{ hover }">
                          <div>
                            <span>{{ $t(header.text) }}</span>
                            <v-icon
                              v-if="
                                hover &&
                                header.value != 'data-table-select' &&
                                header.value != 'actions'
                              "
                              color="white"
                              class="mx-2"
                              @click="on.sort(header.value)"
                            >
                              {{
                                props.options.sortBy.includes(header.value)
                                  ? `mdi-chevron-down`
                                  : `mdi-chevron-up`
                              }}
                            </v-icon>
                          </div>
                        </v-hover>
                      </div>
                    </th>
                  </tr>
                </thead>
              </template>

              <template v-slot:[`item.osType`]="{ item }">
                {{ item.serviceOrderType }}
              </template>

              <template v-slot:[`item.solicited`]="{ item }">
                {{ item.totalRequestedServices }}
              </template>

              <template v-slot:[`item.conclued`]="{ item }">
                {{ item.totalCompletedServices }}
              </template>
            </v-data-table>
            <div class="pagination" v-if="!filterProp.data">
              <div class="item-pagination block-two">
                <v-pagination
                  class="pagination-item"
                  v-model="page"
                  :length="totalPages"
                  :total-visible="3"
                ></v-pagination>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row class="ma-0">
      <v-col cols="12" v-if="isResult">
        <strong>{{ $t('Análise crítica') }}</strong>
        <p v-html="review"></p>
      </v-col>
      <v-col cols="12" v-else>
        <tiptap-vuetify
          v-model="filter.review"
          :extensions="extensions"
          :label="$t('Análise crítica')"
          :placeholder="
            $t('Digite sua análise crítica para o indicador abaixo')
          "
          :card-props="{ flat: true, outlined: true, rounded: true }"
          class="primary-input"
          outlined
          dense
          hide-details="auto"
        ></tiptap-vuetify>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ChartDataLabels from 'chartjs-plugin-datalabels'
import PieChart from '../../../../charts/pieChart'
import ApiService from '../../../../../../../../services/ApiService'
import { GChart } from 'vue-google-charts/legacy'
import TNoContent from '../../../../../../../../components/T/TNoContent.vue'
import moment from 'moment'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  components: {
    PieChart,
    GChart,
    TNoContent,
    TiptapVuetify,
  },

  props: {
    filterProp: Object,
    institution: Object,
    unidades: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  data() {
    return {
      chartKey: false,
      startDate: '',
      endDate: '',
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      filter: {},
      apiService: new ApiService(),
      showChart: true,
      loading: false,
      services: [],
      page: 1,
      haveResponse: false,
      googleChartData: [],
      opt: {
        colors: ['#212950', '#C4E8F2'],
        legend: {
          position: 'top',
        },
        hAxis: {
          minValue: 0,
        },
      },
      totalPages: 1,
      pageSize: 10,
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
      },
      optionsPie: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        plugins: {
          datalabels: {
            font: {
              weight: 'bold',
              size: 11,
            },
          },
        },
      },
      servicesChartData: {},
      requestSolicitedConclued: [],
      pieChartData: {},
      totalSolicited: [],
      totalConclued: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Tipo O.S.',
          align: 'center',
          value: 'osType',
        },
        {
          text: 'Solicitadas',
          align: 'center',
          value: 'solicited',
        },
        {
          text: 'Concluídas',
          align: 'center',
          value: 'conclued',
        },
        {
          text: 'Pendentes',
          align: 'center',
          value: 'pendents',
        },
      ],
      quantity: [],
      backgroundColors: [
        '#426483',
        '#BBCF20',
        '#0F3565',
        '#212950',
        '#C4E8F2',
        '#ED8990',
        '#FDB578',
        '#7EE882',
      ],
      total: 0,
    }
  },

  created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.filter.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.filter.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  methods: {
    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    setInfos() {
      const model = {
        chart: '1.7 - Serviços solicitados x concluídos - Período',
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    async list() {
      if (this.filterProp.data) {
        const response = JSON.parse(this.filterProp.data)
        this.total = response.content.pager.totalItems
        this.totalPages = response.content.pager.totalPages
        this.services = []
        this.labels = []
        this.quantity = []
        this.totalSolicited = []
        this.totalConclued = []
        this.googleChartData = []

        response.content.objects.map((value) => {
          let changedServiceOrderType = this.switchValue(value.serviceOrderType)
          value.serviceOrderType = changedServiceOrderType
          let pendents =
            value.totalRequestedServices - value.totalCompletedServices
          this.services.push({ ...value, pendents })
        })

        this.getBackgroundColors(response.content.chartsModel.length)
        response.content.chartsModel.map((obj) => {
          this.labels.push(this.$t(obj.name))
          this.quantity.push(obj.quantity)
        })

        let totalSolicitedCounter = 0
        let totalCompletedCounter = 0

        this.haveResponse = response.content.objects

        response.content.objects.map((obj) => {
          totalSolicitedCounter += obj.totalRequestedServices
          totalCompletedCounter += obj.totalCompletedServices
        })

        this.totalSolicited.push(totalSolicitedCounter)
        this.totalConclued.push(totalCompletedCounter)

        if (this.haveResponse) {
          this.googleChartData.push([
            'QTD.',
            totalSolicitedCounter,
            totalCompletedCounter,
          ])
          this.googleChartData.unshift([
            this.$t('Números'),
            this.$t('Total solicitado'),
            this.$t('Total concluído'),
          ])
        }
        this.fillChartData()
        this.fillPieChart()

        return
      }

      this.setDates()
      this.filter.institutionId = this.institution.id
      this.filter.pageSize = 7
      this.filter.unidadeIds = this.unidades
      await this.apiService
        .post('reports/requestedCompletedServices', this.filter)
        .then((response) => {
          this.total = response.content.pager.totalItems
          this.totalPages = response.content.pager.totalPages
          this.services = []
          this.labels = []
          this.quantity = []
          this.totalSolicited = []
          this.totalConclued = []
          this.googleChartData = []

          response.content.objects.map((value) => {
            let changedServiceOrderType = this.switchValue(
              value.serviceOrderType
            )
            value.serviceOrderType = changedServiceOrderType
            let pendents =
              value.totalRequestedServices - value.totalCompletedServices
            this.services.push({ ...value, pendents })
          })

          this.getBackgroundColors(response.content.chartsModel.length)
          response.content.chartsModel.map((obj) => {
            this.labels.push(this.$t(obj.name))
            this.quantity.push(obj.quantity)
          })

          let totalSolicitedCounter = 0
          let totalCompletedCounter = 0

          this.haveResponse = response.content.objects

          response.content.objects.map((obj) => {
            totalSolicitedCounter += obj.totalRequestedServices
            totalCompletedCounter += obj.totalCompletedServices
          })

          this.totalSolicited.push(totalSolicitedCounter)
          this.totalConclued.push(totalCompletedCounter)

          if (this.haveResponse) {
            this.googleChartData.push([
              'QTD.',
              totalSolicitedCounter,
              totalCompletedCounter,
            ])
            this.googleChartData.unshift([
              this.$t('Números'),
              this.$t('Total solicitado'),
              this.$t('Total concluído'),
            ])
          }
        })

        .catch((err) => {})

      this.fillChartData()
      this.fillPieChart()
    },

    fillChartData() {
      this.servicesChartData = {
        labels: [''],
        datasets: [
          {
            label: this.$t('Tot. Solicitadas'),
            data: this.totalSolicited,
            backgroundColor: '#212950',
          },
          {
            label: this.$t('Tot. Concluídas'),
            data: this.totalConclued,
            backgroundColor: '#BBCF20',
          },
        ],
      }

      setTimeout(() => {
        this.chartKey = !this.chartKey
      }, 500)
    },

    fillPieChart() {
      this.pieChartData = {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: this.backgroundColors,
            label: '',
            data: this.quantity,
            pointRadius: 5,
            datalabels: {
              anchor: 'center',
              display: true,
              formatter: (value, ctx) => {
                let sum = 0
                let dataArr = ctx.chart.data.datasets[0].data
                dataArr.map((data) => {
                  sum += data
                })
                let percentage = ((value * 100) / sum).toFixed(0) + '%'
                return percentage
              },
              color: '#fff',
            },
          },
        ],
      }

      console.log(this.pieChartData)

      setTimeout(() => {
        this.chartKey = !this.chartKey
      }, 500)
    },
    getBackgroundColors(length) {
      this.backgroundColors = [
        '#426483',
        '#BBCF20',
        '#0F3565',
        '#212950',
        '#C4E8F2',
        '#ED8990',
        '#FDB578',
        '#7EE882',
      ]

      for (let i = 0; i < length; i++) {
        this.backgroundColors.push(
          `#${Math.floor(Math.random() * 16777215).toString(16)}`
        )
      }
    },
    switchValue(val) {
      switch (val) {
        case 0:
          return this.$t('Treinamento')
        case 1:
          return this.$t('Segurança elétrica')
        case 2:
          return this.$t('Preventiva')
        case 3:
          return this.$t('Instalação')
        case 4:
          return this.$t('Rotina de Inspeção')
        case 5:
          return this.$t('Corretiva')
        case 6:
          return this.$t('Calibração')
        case 7:
          return this.$t('Validação/Qualificação')
        case 8:
          return this.$t('Serviços Administrativos')
      }
    },

    printUniqueResults(arrayOfObj, key) {
      // essa função remove os indices repetidos do array
      return arrayOfObj.filter((item, index, array) => {
        return array.map((mapItem) => mapItem[key]).indexOf(item[key]) === index
      })
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>
